// Re-export SharedVideoPlayer as TeamGamesVideoPlayer for backwards compatibility
import SharedVideoPlayer from '../../../components/SharedVideoPlayer';

const TeamGamesVideoPlayer = (props) => <SharedVideoPlayer {...props} />;

export default TeamGamesVideoPlayer;
